import React, { Component, Fragment, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import service from '../services/service';
import CryptoJS from "crypto-js";
import './hearderSearchCourseList.css';

export default function HearderSearchCourseList() {

    const history = useHistory();

    let currentCourseState;

    useEffect(() => {
        const fetchPosts = async () => {

            const res = await service.getPublishCourses();
            setCourseState(res.data);
        };
        fetchPosts();
    }, []);

    const [courseState, setCourseState] = useState([]);

    let value = useSelector(state => state.inputValue);

    const filteredCourses = value
        ? courseState
            .filter(course =>
                course.courseName
                    ?.toLowerCase()
                    .includes(value.toLowerCase())
            )
            .slice(0, 1000)
        : [];

    const CourseDetails = (id, tid, status) => {

        const secretKey = "cdac@123"

        const encodedCourseId = CryptoJS.AES.encrypt(
            `${id}`,
            secretKey
        ).toString();
        const safeEncodedCourseId = encodedCourseId
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");

        const encodedTenantId = CryptoJS.AES.encrypt(
            `${tid}`,
            secretKey
        ).toString();
        const safeEncodedTenantId = encodedTenantId
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");

        history.push(`${process.env.PUBLIC_URL + "/course-details/"}${safeEncodedCourseId}/${safeEncodedTenantId}/${status}`);
        //console.log("before load");
        window.location.reload();

    }

    return (
        <div className="course-search-container">
            <ul className="course-search-list">
                {filteredCourses.length === 0 && (
                    <li className="course-search-empty">No courses found</li>
                )}

                {filteredCourses.map(course => (
                    <li
                        key={course.courseId}
                        className="course-search-item"
                        role="button"
                        tabIndex={0}
                        onClick={() => CourseDetails(course.courseId, 1, course.status)}
                        onKeyDown={(e) =>
                            e.key === 'Enter' && CourseDetails(course.courseId, 1, course.status)
                        }
                    >
                        <span className="course-name"><i className="fa fa-book me-2"></i> {course.courseName}</span>
                        <span className="course-arrow"> ›</span>
                    </li>
                ))}
            </ul>
        </div>
    );

}